import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ApiService }                        from '../../api/api.service';
import { SessionService }                    from '../../sessions/session.service';
import { CustomerMessagesSettingsComponent } from './customer-messages.settings.component';

export const CustomerMessagesStates : Array<NgHybridStateDeclaration> = [
  {
    component: CustomerMessagesSettingsComponent,
    name     : 'app.customer-messages-settings',
    url      : '/customer-messages-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) => apiService.get('/company_integrations'),
        token    : 'settings'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) => apiService.get('/sms_global_account/sms_global_account_quote'),
        token    : 'quote'
      }
    ]
  }
];
